import { Box, Button, CircularProgress, Link, Table, Typography, IconButton } from "@mui/joy";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Util } from "../Helpers/Util";
import ElevatorNotesDialog from "../Dialogs/ElevatorNotesDialog";
import EditNoteIcon from "@mui/icons-material/EditNote";

export default function OutOfServiceElevators() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [loading, setLoading] = React.useState(true);
	const [notesDialogOpen, setNotesDialogOpen] = React.useState(false);
	const [selectedElevator, setSelectedElevator] = React.useState<any>(null);

	const n = useNavigate();

	React.useEffect(() => getData(), []);

	const getData = () => {
		setLoading(true);
		fetch("Building/GetOutOfServiceElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	const handleOpenNotesDialog = (elevator: any) => {
		setSelectedElevator(elevator);
		setNotesDialogOpen(true);
	};

	const handleCloseNotesDialog = () => {
		setNotesDialogOpen(false);
		setSelectedElevator(null);
	};

	const handleSaveNotes = async (elevatorId: string, notes: string) => {
		try {
			const response = await fetch("Building/SaveElevatorNotes", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					elevators_id: elevatorId,
					notes: notes,
				}),
			});

			if (!response.ok) {
				throw new Error("Failed to save notes");
			}

			// Refresh the data to show updated notes
			getData();
		} catch (error) {
			console.error("Error saving elevator notes:", error);
			throw error;
		}
	};

	return (
		<>
			<Box sx={{ overflowY: "auto", padding: 2 }}>
				<Typography level="title-lg" sx={{ marginBottom: 2 }}>
					Out of Service Elevators
				</Typography>
				<Table>
					<thead>
						<tr>
							<th>Building</th>
							<th>Serial Number</th>
							<th>Date Out of Service</th>
							<th>Notes</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{loading && (
							<tr>
								<td colSpan={5}>
									<div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
										<CircularProgress />
									</div>
								</td>
							</tr>
						)}
						{!loading &&
							dataset.map((x) => (
								<tr key={x.elevators_id}>
									<td>
										<Link
											onClick={() => {
												n("/buildingportal/" + x.buildings_id);
											}}>
											{x.name || x.building_name}
										</Link>
									</td>
									<td>{x.serial_number}</td>
									<td>{Util.Formatter(x.date_out_of_service, "D")}</td>
									<td>
										{ x.notes ? (
											<span title={x.notes}>
												{x.notes.length > 50 ? x.notes.substring(0, 50) + "..." : x.notes}
											</span>
										) : (
											<span style={{ color: "#999" }}>No notes</span>
										)}
									</td>
									<td>
										<IconButton
											size="sm"
											onClick={() => handleOpenNotesDialog(x)}
											title="Edit Notes"
										>
											<EditNoteIcon />
										</IconButton>
									</td>
								</tr>
							))}
					</tbody>
				</Table>
			</Box>
			
			{selectedElevator && (
				<ElevatorNotesDialog
					open={notesDialogOpen}
					onClose={handleCloseNotesDialog}
					elevatorId={selectedElevator.elevators_id}
					elevatorSerialNumber={selectedElevator.serial_number}
					buildingName={selectedElevator.name || selectedElevator.building_name}
					initialNotes={selectedElevator.notes}
					onSave={handleSaveNotes}
				/>
			)}
		</>
	);
}
